import Badge from '../../common/component/Badge';
import EllipsisText from '../../common/component/EllipsisText';
import PageImage from '../../common/component/PageImage';
import SingleText from '../../common/component/SingleText';
import {EVENT_MAX_WIDTH_272_CN} from '../common';
import {IEventItemV4} from '../type';

interface IProps {
  item: IEventItemV4;
}

export default function EventItemV4({item}: IProps) {
  const {label, section, image} = item;
  const {title, description} = section ?? {};

  return (
    <div className="flex flex-col">
      <Badge
        variant="s10_white_black"
        label={label}
        className="!px-8 self-start flex-center tracking-[-0.4px]"
      />
      {title && (
        <EllipsisText
          line={3}
          className={cn(
            EVENT_MAX_WIDTH_272_CN,
            'mt-16',
            's20-bold-white leading-26 tracking-[-0.5px]'
          )}
        >
          {title}
        </EllipsisText>
      )}
      {description && (
        <SingleText
          className={cn(
            EVENT_MAX_WIDTH_272_CN,
            'mt-6 opacity-80',
            's13-regular-white leading-16 tracking-[-0.4px]'
          )}
        >
          {description}
        </SingleText>
      )}
      {image && (
        <PageImage
          src={image}
          alt="Event"
          pictureClassName="mx-auto mt-19"
          className="max-w-[339px]"
        />
      )}
    </div>
  );
}
